export enum ColorModeEnum {
    TOKEN = 'token',
    RGBA = 'rgba',
    GRADIENT = 'gradient',
}
